// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"Benefits__materialize-textarea___39tay","modal-2463794813":"Benefits__modal-2463794813___1cjl9","container":"Benefits__container___1jMzl","benefitsContainer":"Benefits__benefitsContainer___2BcIQ","desc":"Benefits__desc___3nLkK","redDot":"Benefits__redDot___3yeEq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Benefits/Benefits.scss
// module id = 1468
// module chunks = 0